/**
 * Copyright (c) 2023, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
 *
 * WSO2 LLC. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

export const formatDateTime = (dateString) => {
  // Create a Date object from the input string
  const dateObject = new Date(dateString);

  // Get the month abbreviation (e.g., Nov)
  const monthAbbreviation = new Intl.DateTimeFormat("en-US", {
    month: "short"
  }).format(dateObject);

  // Get the day and time (e.g., 06 10:06)
  const dayAndTime = new Intl.DateTimeFormat("en-US", {
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  }).format(dateObject);

  // Get the UTC offset (e.g., UTC)
  const utcOffset = "UTC";

  // Combine the formatted parts to create the final string
  return `${monthAbbreviation} ${dayAndTime} ${utcOffset}`;
};

export const formatDate = (dateString) => {
  // Create a Date object from the input string
  const dateObject = new Date(dateString);

  // Get the month abbreviation (e.g., Nov)
  const monthAbbreviation = new Intl.DateTimeFormat("en-US", {
    day: "2-digit",
    month: "long",
    year: "numeric"
  }).format(dateObject);

  // Combine the formatted parts to create the final string
  return `${monthAbbreviation}`;
};

export const formatMonth = (dateString) => {
  // Output format: November 2021
  return new Date(dateString.split("-")[0], dateString.split("-")[1] - 1, 1).toLocaleString("default", {
    month: "long",
    year: "numeric"
  });
};

export const formatTime = (dateString) => {
  // Create a Date object from the input string
  const dateObject = new Date(dateString);

  // Get the day and time (e.g., 06 10:06)
  const dayAndTime = new Intl.DateTimeFormat("en-US", {
    hour: "2-digit",
    minute: "2-digit"
  }).format(dateObject);

  // Get the UTC offset (e.g., UTC)
  const utcOffset = "UTC";

  // Combine the formatted parts to create the final string
  return `${dayAndTime} ${utcOffset}`;
};

export const toNormalCase = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
